import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import dompurify from 'dompurify';
import { get } from 'lodash';
import { Component } from 'react';
import { PhoneExpandable } from 'src/_shared/components/phone-expandable';
import { isPhone } from 'src/_shared/phone.js';
import { showingLess, textFade } from './referralPolicyStyles.js';

const sanitizer = dompurify.sanitize;

class BaseReferralPolicyCard extends Component {
	state = {
		isViewBoxExpanded: false,
	};

	render() {
		const { title, currentUser, minHeight } = this.props;
		const { isViewBoxExpanded } = this.state;
		const policy = (
			<div
				dangerouslySetInnerHTML={{
					__html: sanitizer(
						get(
							currentUser,
							'company.dashboardReferralPolicyText',
							''
						).toString('html')
					),
				}}
				className="referral-policy"
			/>
		);
		return (
			<div className="d-card">
				{title && (
					<div className="d-card-head">
						<h4 className="d-title">{title}</h4>
					</div>
				)}
				{isPhone() ? (
					// Same Show more treatment as the other dashboard cards (ERIN-8561).
					<PhoneExpandable collapsedHeight={260}>{policy}</PhoneExpandable>
				) : (
					<>
						<div className={`${isViewBoxExpanded ? '' : showingLess}`}>
							{policy}
							<div className={textFade} />
						</div>
						<Button
							type="link"
							style={{ color: '#018dd3', fontWeight: 600 }}
							onClick={() =>
								this.setState({ isViewBoxExpanded: !isViewBoxExpanded })
							}
						>
							{isViewBoxExpanded ? <UpOutlined /> : <DownOutlined />}
						</Button>
					</>
				)}
			</div>
		);
	}
}

export const ReferralPolicyCard = BaseReferralPolicyCard;
